/** Run an async function with a 10s timeout, cancelling on outer signal abort. */
export async function withTimeout<T>(
  outerSignal: AbortSignal,
  fn: (signal: AbortSignal) => Promise<T>,
): Promise<T> {
  const ctrl = new AbortController();
  const timer = setTimeout(() => ctrl.abort(), 10_000);
  const onOuterAbort = () => ctrl.abort();
  outerSignal.addEventListener("abort", onOuterAbort, { once: true });
  try {
    return await fn(ctrl.signal);
  } finally {
    clearTimeout(timer);
    outerSignal.removeEventListener("abort", onOuterAbort);
  }
}
